import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "nav_arrow_goto",
  "use": "nav_arrow_goto-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"nav_arrow_goto\"><path d=\"M8.5 7.6c0 .5-.4.9-.9.9H2.4c-.5 0-.9-.4-.9-.9V2.4c0-.5.4-.9.9-.9h.1C3.33 1.5 4 .83 4 0H2.4A2.4 2.4 0 000 2.4v5.2A2.4 2.4 0 002.4 10h5.2A2.4 2.4 0 0010 7.6V6c-.83 0-1.5.67-1.5 1.5v.1zM5.75 0C5.34 0 5 .34 5 .75s.34.75.75.75h1.69L3.97 4.97c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22L8.5 2.56v1.69c0 .41.34.75.75.75s.75-.34.75-.75V0H5.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol